import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import { Provider } from 'react-redux';
import { persistedStore, store } from './Store';
import { PersistGate } from 'redux-persist/integration/react';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistedStore}>
      <App/>
    </PersistGate>
  </Provider>,
  document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js